export const ORGANIZATIONS_EDIT_FORM_NAME = 'organizationsEdit'

export const USERS_FILTER = {
  POST: 'HaveNotAcceptedInvitation',
  FIRE_OUTLINE: 'HaveNotStartProTrack',
  FIRE_OUTLINE_PAUSED_PROTRACK: 'StoppedProTrack',
  FIRE_OUTLINE_COMPLETED_PROTRACK: 'FinishedProTrack',
  FIRE_OUTLINE_RUNNING_PROTRACK: 'RunningProTrack',
  SCHEDULED_INVITE_USERS: 'ScheduledInviteUsers',
  ALL: 'all',
}

export const USERS_TEAM_FILTER = {
  WITHOUT: 'WithoutTeams',
  ALL: 'all',
}

export const FULLNAME = 'fullName'
export const FIRSTNAME = 'firstName'
export const USERS = 'users'
export const ALL = 'all'
